import '.y{width:100%;}.ssr-plugin'
import '.ep{border-radius:0.75rem;}.ssr-plugin'
import '.eq{border:1px solid var(--shades-blue-300);}.ssr-plugin'
import '.em{padding:0.5rem 1rem;}.ssr-plugin'
import '.er{font-size:1.125rem;}.ssr-plugin'
import '.e1{line-height:1.75rem;}.ssr-plugin'
import '.es{resize:vertical;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { forwardRef } from 'react'

export type MultiLineTextInputProps = {
  value: string
  placeholder?: string
  minHeight?: string
  style?: Style
  setValue: (value: string) => void
}

export const MultiLineTextInput = forwardRef<
  HTMLTextAreaElement,
  MultiLineTextInputProps
>(
  (
    {
      value,
      placeholder,
      minHeight = '6.5rem',
      style,
      setValue,
    }: MultiLineTextInputProps,
    ref,
  ) => {
    return (
      <styled.textarea className="y ep eq em er e1 es"
        ref={ref}
        style={{
          minHeight: minHeight,
          '&:focus': {
            outline: 'none',
            border: '1px solid var(--primary-blue)',
          },
          ...style,
        }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      ></styled.textarea>
    )
  },
)
